export default "__VITE_ASSET__BFHke$bu__"